<script>
export default {
  props: {
    mode: {
      type: String,
      default: 'multiple'
    }
  },
  data() {
    this.fetchBillers = _.debounce(this.fetchBillers, 800)
    return {
      data: [],
      value: [],
      fetching: false
    }
  },
  methods: {
    fetchBillers(value) {
      this.data = []
      this.fetching = true
      this.$http.get(this.routeUri('hyperion.biller'), {
        params: {q: value}
      })
        .then((response) => this.data = response.data.data)
        .finally(() => this.fetching = false)
    },
    handleChange(value) {
      let map = _.map(value, 'key')
      this.$emit('change', _.filter(this.data, (o) => map.includes(o.id)))
      Object.assign(this, {
        value,
        data: [],
        fetching: false
      })
    },
    selected(item) {
      this.$emit('selected', item)
    }
  }
}
</script>
<template>
  <a-select
    labelInValue
    :mode="mode"
    :value="value"
    placeholder="Select Biller"
    style="width: 100%"
    :filterOption="false"
    @search="fetchBillers"
    @change="handleChange"
    @select="selected"
    @focus="fetchBillers"
    :notFoundContent="fetching ? undefined : null "
    :loading="fetching">
    <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
    <a-select-option v-for="d in data" :key="d.id" :value="d.id">{{ d.name }}</a-select-option>
  </a-select>
</template>
